import { BannerError } from './BannerError';

export type { TypeBannerErrorProps } from './types';
export default BannerError;
